export default "__VITE_ASSET__y8qOVvSG__"